////////////////////////////////////////////////////////////////////////////////
// Copyright 2019 Federated Wireless.
//
// GOVERNMENT PURPOSE RIGHTS
//
// Contractor Name:    Federated Wireless
// Contractor Address: 3865 Wilson Blvd, Arlington, VA 22203
//
// The Government's rights to use, modify, reproduce, release, perform, display,
// or disclose this software are restricted by paragraph (b)(2) of the Rights in
// Noncommercial Computer Software and Noncommercial Computer Software
// Documentation clause contained in the 7013 Clause. Any reproduction of the
// software or portions thereof marked with this legend must also reproduce the
// markings.
// This source code delivery is exclusively for Government Purposes pertaining
// to this program; no commercial use. The Computer Software Configuration
// Items were delivered for only the purposes spelled out by the contract
// delivered under.
//
// Export Warning - The technical data in this document (or file) is
// controlled for export under the International Traffic in Arms Regulations
// (ITAR), 22CFR 120-130.  Violations of these export laws may be subject to
// fines and penalties under the Arms Export Control Act (22 U.S.C. 2778).
//
////////////////////////////////////////////////////////////////////////////////
//
// Security Classification: UNCLASSIFIED
//
////////////////////////////////////////////////////////////////////////////////

/*global google*/

import React, { Component } from 'react';
import axios from 'axios'
import { Chart } from "react-google-charts";
import styles from './styles.module.css'

const bandwidthSelection = [ 1.4, 3, 5, 10, 15, 20, 25, 30, 40, 50, 60, 70, 80, 90, 100 ]
const { compose, withProps } = require("recompose");
const {
    withScriptjs,
    withGoogleMap,
    Polygon,
    GoogleMap
  } = require("react-google-maps");
const { DrawingManager } = require("react-google-maps/lib/components/drawing/DrawingManager");

class MapSelection extends Component {
  constructor(props) {
      super(props);
      this.setBandwidth = this.setBandwidth.bind(this);
    }

    state = {
      submitted: false,
      failed:false,
      spectrumPlot: null,
      default_center:{
        lat: 59.0084,
        lng: 3.1214,
      },
      saveAndExit:false,
      spectrumPlotStatus: "hidden",
      selectedNetworkAreas:[],
      chart_min: 758,
      chart_max: 2000,
      unavail_color:"#ff8f05",
      available_narrower_bandwidth_color:'#70a2ff',
      available_color: "#0050E6",
      unusable_color:"#f2f2f2",
      selected_color:"#EE26B9",
      series_spec:{},
      series_index: -1,
      display: "after",
      bandwidth: 20,
      series_lookup:[],
      highlighted_freqs: [],
      selected_freqs: [],
      map_init: false,
      selected_frequency_range_ok: false,
      selected_areas_ok: false,
      selected_areas_ok_in_frequency_range: false,
      overlayMaps: [],
      selected_overlay_index: null
    }

  MapWithADrawingManager = compose(
    withProps({
      googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${localStorage.getItem("google_maps_api_key")}&v=3.exp&libraries=geometry,drawing,places`,
      loadingElement: <div style={{ height: `100%` }} />,
      containerElement: <div style={{ height: `600px` }} />,
      mapElement: <div style={{ height: `100%` }} />,
    }),
    withScriptjs,
    withGoogleMap
  )(props =>
    <GoogleMap
      ref={map => this._map = map}
      defaultZoom={8}
      defaultCenter={new google.maps.LatLng(59.0084, -3.9605)}
      options={{
        "mapTypeControlOptions": {
          position: google.maps.ControlPosition.TOP_RIGHT
        },
        "zoomControlOptions" : {
          position: google.maps.ControlPosition.TOP_LEFT
        },
        streetViewControl: false,
        gestureHandling: "greedy",
        styles: [
          {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [
              {color: '#f5fcff'}
            ]
          },
          {
            featureType: 'landscape',
            elementType: 'geometry.fill',
            stylers: []
          }
        ]
      }}
      onTilesLoaded={() => {
        // Get MNO coverage polygons which overlap visible map bounds from back-end
        // Need access to raw Google Maps object, which React wrapper helpfully hides...
        const map = this._map.context['__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED'];

        // nasty workaround to React Google Maps wrapper not having an onInit callback (!!!)
        if (!this.state.map_init) {
          this.modifyState({map_init: true})
          this.onMapInit(map);
        }
      }
    }
    >
      <DrawingManager
        defaultDrawingMode={google.maps.drawing.OverlayType.POLYGON}
        onPolygonComplete={(poly) => {
            const polyArray = poly.getPath().getArray();
            let paths = [];
            polyArray.forEach(function(path){
              paths.push({lat:path.lat(), lng: path.lng()});
            });

            const networkAreaList = [...this.state.selectedNetworkAreas]
            networkAreaList.push(paths)
            this.modifyState({selectedNetworkAreas:networkAreaList})
            poly.setMap(null)
            this.calculateAvailableSpectrum()
         }}
        defaultOptions={{
          drawingControl: true,
          drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: [
              google.maps.drawing.OverlayType.POLYGON,
            ],
          }
        }}
      />
    {props.networkAreas}
    </GoogleMap>
  );    

  onMapInit(map) {
    map.setMapTypeId('terrain');
    [].forEach.call(document.getElementsByClassName(styles.customMapControl), function (el) {
      map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(el);
    });

    var overlayMaps = [];

    for (let mno_name of ['Vodafone', 'O2', 'EE', 'Three']) {
      for (let technology of ["4g", "no4g"]) {
        overlayMaps.push(
          {
            getTileUrl: function(mno_name_, technology_) {
              return function(coord, zoom) {
                return `${process.env.REACT_APP_LAL_ENDPOINT}/mno_coverage_tiles/${mno_name_}/${technology_}/${zoom}/${coord.x}/${coord.y}.png`
              }
            } (mno_name, technology),
            name: `${mno_name}-${technology}`,
            tileSize: new google.maps.Size(256, 256),
            isPng: true,
            opacity: 0.8,
            minZoom: 7,
            maxZoom: 15
          }
        );
      }
    }

    this.modifyState({overlayMaps: overlayMaps})
    if (this.state.selected_freqs)
      this.showCoverageLayer();
  }

  modifyState = (state, callback) => {
    this.setState(state, callback);
    this.props.updatePageState("MapSelection", state);
  }

  componentDidMount() {
    if (this.props.getPageState("MapSelection")){
        this.setState(this.props.getPageState("MapSelection"));
        // map sure map is properly initialized after returning to this page from the next one.
        this.modifyState({map_init: false})

        return;
    }

    this.calculateAvailableSpectrum();
  }

  showCoverageLayer() {
    // Google Maps' helpful nomenclature for "rasterLayers"
    const overlayMapTypes = this.getMap().overlayMapTypes;

    if (this.state.selected_freqs.length === 0) {
      // show nothing
      if (overlayMapTypes.getLength() > 0)
        overlayMapTypes.clear();
        this.modifyState({selected_overlay_index: -1})
    } else {
      const freqs_to_show = this.state.selected_freqs;

      let technology = "none"

      if (this.getMap().getBounds().getSouthWest().lat() > 58) {
        // based on Villicom measurements around Orkney, show relevant coverage data per band *NOT APPLICABLE IN WHOLE UK!*
        if (freqs_to_show[2] === "Vodafone" || freqs_to_show[2] === "O2") {
          if (freqs_to_show[0] >= 800 && freqs_to_show[0] < 900)
            technology = "4g"
          else if (freqs_to_show[0] >= 900 && freqs_to_show[0] <= 1000)
            technology = "no4g"
          else if (freqs_to_show[0] >= 2100 && freqs_to_show[0] <= 2350)
            technology = "4g"
        } else if (freqs_to_show[2] === "EE" || freqs_to_show[2] === "Three") {
          if (freqs_to_show[0] >= 791 && freqs_to_show[0] < 900)
            technology = "4g"
          else if (freqs_to_show[0] >= 1800 && freqs_to_show[0] <= 1900)
            technology = "4g"
          else if (freqs_to_show[0] >= 2100 && freqs_to_show[0] <= 2350)
            technology = "no4g"
        }
      } else {
        if (freqs_to_show[2] === "Vodafone") {
          if (freqs_to_show[0] >= 800 && freqs_to_show[0] < 900)
            technology = "4g"
          else if (freqs_to_show[0] >= 900 && freqs_to_show[0] <= 1000)
            technology = "no4g"
          else if (freqs_to_show[0] >= 1450 && freqs_to_show[0] <= 1500)
            technology = "4g"
          else if (freqs_to_show[0] >= 1800 && freqs_to_show[0] <= 1900)
            technology = "no4g"
          else if (freqs_to_show[0] >= 2620 && freqs_to_show[0] <= 2690)
            technology = "4g"
        } else if (freqs_to_show[2] === "O2") {
          if (freqs_to_show[0] >= 800 && freqs_to_show[0] < 900)
            technology = "4g"
          else if (freqs_to_show[0] >= 1800 && freqs_to_show[0] <= 1900)
            technology = "4g"
          else if (freqs_to_show[0] >= 900 && freqs_to_show[0] <= 1000)
            technology = "no4g"
          else if (freqs_to_show[0] >= 2100 && freqs_to_show[0] <= 2390)
            technology = "4g"
        } else if (freqs_to_show[2] === "EE") {
          if (freqs_to_show[0] >= 791 && freqs_to_show[0] < 900)
            technology = "4g"
          else if (freqs_to_show[0] >= 1800 && freqs_to_show[0] <= 1899)
            technology = "4g"
          else if (freqs_to_show[0] >= 2100 && freqs_to_show[0] <= 2350)
            technology = "4g"
          else if (freqs_to_show[0] >= 2640 && freqs_to_show[0] <= 2690)
            technology = "4g"
        } else if (freqs_to_show[2] === "Three") {
          if (freqs_to_show[0] >= 791 && freqs_to_show[0] < 900)
            technology = "4g"
          else if (freqs_to_show[0] >= 1450 && freqs_to_show[0] <= 1500)
            technology = "4g"
          else if (freqs_to_show[0] >= 1800 && freqs_to_show[0] <= 1900)
            technology = "4g"
          else if (freqs_to_show[0] >= 2100 && freqs_to_show[0] <= 2350)
            technology = "no4g"
        }
      }

      const mno_names = ['Vodafone', 'O2', 'EE', 'Three'];
      const mno_index = mno_names.indexOf(freqs_to_show[2]);

      if (technology !== "none" && mno_index > -1) {
        const index = 2 * mno_index + (technology === 'no4g' ? 1 : 0);
        const layer_name = `${mno_names[mno_index]}-${technology}`

        if (!overlayMapTypes.getAt(0) || overlayMapTypes.getAt(0).name !== layer_name) {
          overlayMapTypes.clear();
          overlayMapTypes.setAt(0, new google.maps.ImageMapType(this.state.overlayMaps[index]));
          this.modifyState({selected_overlay_index: index})
        }
      } else {
        if (overlayMapTypes.getLength() > 0)
          overlayMapTypes.clear();
          this.modifyState({selected_overlay_index: -1})
      }
    }
  }

  getMap() {
    // Need access to raw Google Maps object, which React wrapper helpfully hides...
    return this._map.context['__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED'];
  }

  setBandwidth(event) {
    this.modifyState({bandwidth: parseInt(event.target.value)});

    this.calculateAvailableSpectrum();
  }

  calculateAvailableSpectrum() {
    // Which frequency ranges are both available to LALs and unoccupied in the user's selected areas?
    // (i.e. populate ribbon plot)

    const config = {
      headers: { 'content-type': 'application/json' }
    }

    const selectedAreas = [...this.state.selectedNetworkAreas]
    if (selectedAreas.length > 0)
      this.modifyState({"selected_areas_ok": true});

    const URL = `${this.props.SERVER_URLS.api}/maps/${this.props.id}?bandwidth=${this.state.bandwidth}`

    axios.post(URL, {"selected_areas": selectedAreas, "request_state":1, "user_id": localStorage.getItem("user_id")}, config)
      .then(response =>{
        if (response.data.error) {
          this.setState({spectrumPlotStatus: "failed"});
          return;
        }

        let series_lookup = [];
        const frequency_ranges = response.data.frequency_ranges;
        if (frequency_ranges.length === 0) {
          return;
        }

        // Build Ribbon Plot.
        // This is something of a workaround to achieve what we want using Google's stacked bar chart
        // which wasn't really designed for this purpose.
        // interleaving actual data elements and tooltip elements so that
        // each part of the stacked bar chart gets its own custom tooltip text

        let a = ['', '', {role: "tooltip", type: "string", p: { html: true } }]
        let b = ['', this.state.chart_min, 'dummy tooltip']
        let c = ['']

        for (let fr of frequency_ranges) {
          const f = fr['freq_MHz'];
          series_lookup.push([f[0], f[1], fr["description"]])

          a.push('') // need a value here, don't care what it is
          // actual width of the bar (in MHz) - capped above for visual clarity
          b.push(Math.min(f[1]-f[0], 50));

          // determine the colour of the bar and the appropriate tooltip text
          let tooltipText = `${f[0]} - ${f[1]} MHz`;

          if (!fr["available"]) {
            c.push(this.state.unusable_color)
            if (fr["description"] === "Uplink")
              tooltipText += '\nLAL frequency range (uplink band)'
            else
              tooltipText += '\nNot a LAL frequency range'
          } else if (fr["occupied"]) {
            c.push(this.state.unavail_color)
            tooltipText += ` (${fr["description"]})\n In use by MNO in selected area(s)`
          } else if (f[1]-f[0] >= this.state.bandwidth){
            c.push(this.state.available_color)
            if (selectedAreas.length > 0)
              tooltipText += ` (${fr["description"]})\n Available for LAL use in selected area(s)`
            else
              tooltipText += ` (${fr["description"]})\n Select an area on the map to find LAL availability`
          } else {
            c.push(this.state.available_narrower_bandwidth_color)
            if (selectedAreas.length > 0)
              tooltipText += ` (${fr["description"]})\n Available for LAL use in selected area(s) at <${this.state.bandwidth} MHz)`
            else
              tooltipText += ` (${fr["description"]})\n Select an area on the map to find LAL availability`
          }

          // add the tooltip element
          a.push({ role: "tooltip", type: "string", p: { html: true } })
          b.push(tooltipText)
        }

        // hide the legend for the existing columns, as it won't make any sense
        let series_spec={}
        for (let i=0; i<c.length; i++) {
          series_spec[i]={ visibleInLegend: false}
        }

        // now hack in some dummy columns to get the legend we want
        a.push("Unusable by LALs", "In use by MNO", `Available at <${this.state.bandwidth} MHz`, "Available", "Selected")
        b.push(0, 0, 0, 0, 0)
        c.push(this.state.unusable_color, this.state.unavail_color, this.state.available_narrower_bandwidth_color, this.state.available_color, this.state.selected_color)
        for (let i=series_spec.length; i<c.length; i++) {
          series_spec[i]={ visibleInLegend: true}
        }

        this.modifyState({
          chart_headers:a,
          chart_data:b,
          chart_colors:c,
          chart_default_colors:[...c],
          series_spec:series_spec,
          spectrumPlotStatus: "show",
          series_lookup: series_lookup
        });

        this.styleSelection(this.state.series_index);
      }).catch(
        function(error) {
          console.log(error)
      })
  }

    wrapNetworkAreas(networkAreas){
        let wrappedNetworkAreas=[]
        for (let i in networkAreas){
        wrappedNetworkAreas.push(<Polygon
            path={networkAreas[i]}
            key={i}
            options={{
                fillColor: "#0050E6",
                fillOpacity: 0.1,
                strokeColor: "#0050E6",
                strokeOpacity: 1,
                strokeWeight: 3,
                zIndex: 9999999
            }}
            onClick={() => {
                console.log("ahmet")
            }}/>)
        }
        return wrappedNetworkAreas
    }

  renderError = ({ meta: { touched, error } }) =>
    touched && 
    error ? <span>{error}</span> : false

  styleSelection(series_index) {
      // don't carry restyling over from one selection to the next
      let chart_colors = [...this.state.chart_default_colors];

      // this is a pretty nasty way to make this decision...
      this.modifyState({"selected_frequency_range_ok": chart_colors[series_index + 1] === this.state.available_color || chart_colors[series_index + 1] === this.state.unavail_color});
      this.modifyState({"selected_areas_ok_in_frequency_range": chart_colors[series_index + 1] === this.state.available_color});

      // crudely restyle the selected bar
      if (series_index >= 0)
        chart_colors[series_index + 1] = this.state.selected_color;

      this.modifyState({chart_colors: chart_colors});
  }

  hasSelection() {
    return this.state.series_index >= 0;
  }

  getIncumbentUserOfSelection() {
    const series_index = this.state.series_index;

    return series_index >= 0 ? this.state.series_lookup[series_index][2] : "";
  }

  getSelectedFrequencyRange() {
    const series_index = this.state.series_index;

    return series_index >= 0 ? `${this.state.series_lookup[this.state.series_index][0]} to ${this.state.series_lookup[this.state.series_index][1]} MHz` : "";
  }

  render(){
    var { handleSubmit, previousPage } = this.props;
    return (
      <React.Fragment>
        <h3>Step 2: Assess whether LAL frequencies are available in your area <em>for Ofcom OfW588 form, Section C12</em></h3>
        <div className={'alert ' + (!this.getSelectedFrequencyRange() ? 'alert-primary' : this.state.selected_frequency_range_ok ? 'alert-success' : 'alert-danger')} role="alert">
          {!this.getSelectedFrequencyRange() ?
            'Which frequency range will your LAL network use?' :
            this.state.selected_frequency_range_ok ?
              'You have chosen ' + this.getSelectedFrequencyRange() + ' for your LAL network.' :
              'You have chosen ' + this.getSelectedFrequencyRange() + ', which has insufficient bandwidth. Choose another frequency range, or reduce your chosen bandwidth.'
          }
        </div>

        <center>
          {this.state.spectrumPlotStatus==="show" &&
            <React.Fragment>
            <Chart
              ref={(ref) => this.GoogleChart = ref}
              width={'95%'}
              height={'200px'}
              chartType="BarChart"
              loader={<div>Loading Chart</div>}
              data={[
                this.state.chart_headers,
                this.state.chart_data,
              ]}
              chartEvents={[
                {
                  eventName: "ready",
                  callback: ({ chartWrapper, google }) => {
                    const chart = chartWrapper.getChart();
                    google.visualization.events.addListener(chart, "onmouseover", e => {
                      const { row, column } = e;
                      const series_index = (column - 3) / 2
                      if (series_index >= this.state.series_lookup.length)
                        return;

                      this.state.highlighted_freqs = this.state.series_lookup[series_index];
                    });
                    google.visualization.events.addListener(chart, "onmouseout", e => {
                      this.state.highlighted_freqs = [];
                    });
                  }
                },
                {
                  eventName : 'select',
                  callback  : ({ chartWrapper, google }) => {
                    const chart = chartWrapper.getChart();
                    if (chart.getSelection().length > 0) {
                      let series_index = (chart.getSelection()[0].column - 3) / 2;

                      // do nothing if the user clicked on the legend
                      if (series_index >= this.state.series_lookup.length)
                        return;

                      // select the clicked bar, or deselect if user clicks again on selected, or on a greyed-out bar
                      if (this.state.series_index !== series_index && this.state.chart_colors[series_index + 1] !== this.state.unusable_color) {
                        this.modifyState({series_index: series_index})
                        this.styleSelection(series_index);
                        this.modifyState({"selected_freqs": this.state.series_lookup[series_index]});
                      } else {
                        this.modifyState({series_index: -1})
                        this.styleSelection(-1);
                        this.modifyState({"selected_freqs": []});
                      }
                      this.showCoverageLayer();
                    } else {
                      this.styleSelection(-1);
                      this.modifyState({series_index: -1})
                      this.modifyState({"selected_freqs": []});
                      this.showCoverageLayer();
                    }
                    this.modifyState({spectrumPlot:chart.getImageURI()})
                  }
                }
              ]}
              options={{
                chartArea: { width: '100%',},
                colors: this.state.chart_colors,
                isStacked: true,
                legend: { position: 'top', maxLines: 5, labels: {maxWidth: 50, wrap: true}},
                series: this.state.series_spec,
                hAxis: {
                  title: 'Downlink Frequency (MHz)',
                  minValue: 0,
                  format:'#',
                  ticks: [821, 925, {v: 1005, f: '1452'}, {v: 1170, f: '1805'}, {v: 1384, f: '2110'}, {v: 1634, f: '2620'}, {v: 1944, f: '3600'}],
                  textStyle : {
                    color: '#000000',
                    fontStyle: 'bold',
                    fontSize: 16
                  },
                  viewWindow: {
                    min: this.state.chart_min,
                    max: this.state.chart_max
                  }
                },
                vAxis: {
                  title: '',
                },
              }}
              // For tests
              rootProps={{ 'data-testid': '3' }}
            /></React.Fragment>}

        </center>


        <div className="detail-select">
          <React.Fragment>
            <label>Bandwidth</label>
            <select value={Math.round(this.state.bandwidth.toString())} onChange={this.setBandwidth}>
                {(()=>{
                    let options = []
                    for (let bw of bandwidthSelection){
                        options.push( <option value={bw} >{bw} MHz</option>)
                    }
                    return options
                }
                )()}

            </select>
          </React.Fragment>
        </div>

        <div className={'alert ' + (!this.state.selected_areas_ok ? 'alert-primary' : 'alert-success')} role="alert">
          {!this.state.selected_areas_ok ?
            'Draw on the map your intended coverage area(s).' :
            'You have drawn your intended coverage area(s).'}
        </div>

        <this.MapWithADrawingManager networkAreas={this.wrapNetworkAreas(this.state.selectedNetworkAreas)}/>

        <div className={'alert ' + (!this.state.selected_areas_ok || !this.state.selected_frequency_range_ok? 'alert-primary' : this.state.selected_areas_ok_in_frequency_range ? 'alert-success' : 'alert-danger')} role="alert">
          {!this.state.selected_areas_ok || !this.state.selected_frequency_range_ok?
            'Is your chosen frequency range in use by an MNO in your intended coverage area(s)?' :
            this.state.selected_areas_ok_in_frequency_range ?
              "Your chosen frequency range is not in use by an MNO in your intended coverage area." :
              `Your chosen frequency range is in use by ${this.getIncumbentUserOfSelection()} in your intended coverage area. Choose another frequency range or area.`
          }
        </div>


          <div className="button-row">
            <button type="button" className="btn btn-light btn-lg" disabled={this.state.selectedNetworkAreas.length>0 ?false : true} onClick={()=>{
                const selectedNetworkAreas = this.state.selectedNetworkAreas.slice(0,this.state.selectedNetworkAreas.length-1);

                this.modifyState({selectedNetworkAreas: selectedNetworkAreas}, () => this.calculateAvailableSpectrum());
                if (selectedNetworkAreas.length === 0)
                  this.modifyState({"selected_areas_ok": false});
                }
            }>
            Clear Previous Selection
            </button>
            <button type="button" className="btn btn-light btn-lg" disabled={false} onClick={previousPage}>
                Previous Page
            </button>
            <button type="button" className="btn btn-light btn-lg" disabled={false} onClick={()=>{
                this.props.saveAndExit()
                }}>
            Save and Exit
            </button>
            <button type="button" className="btn btn-primary btn-lg" disabled={this.state.selectedNetworkAreas.length == 0 || this.state.selected_freqs.length == 0} onClick={this.props.onSubmit}>Next Page</button>
          </div>
        <form onSubmit={handleSubmit}>
          <div className={styles.customMapControl}>
            <div>
              <svg height="3em" width="3em" viewBox="0 0 301 301" xmlns="http://www.w3.org/2000/svg">
               <g>
                <rect fill="none" height="303" width="303" y="-1" x="-1"/>
                <ellipse fillOpacity="0.125" ry="145" rx="145" cy="150.25" cx="150.25" strokeWidth="8" stroke="#ff8f05" fill="#ff8f05"/>
               </g>
              </svg>
              <span>{this.hasSelection() ?
                `${this.getIncumbentUserOfSelection()} coverage in ${this.getSelectedFrequencyRange()}` :
                'MNO coverage in selected band'}
              </span>
            </div>

            <div>
              <svg height="3em" width="3em" viewBox="0 0 301 301" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <rect fill="none" height="303" width="303" y="-1" x="-1"/>
                  <rect transform="rotate(30.433414459228516 151,149.953125) " height="148" width="242" y="75.95313" x="30" fillOpacity="0.1" strokeWidth="20" stroke="#0050E6" fill="#0050E6"/>
                </g>
              </svg>
              <span>Your intended coverage area(s)</span>
            </div>
          </div>
        </form>
      </React.Fragment>
    );
  };

}




export default MapSelection



